import {
  camelCase,
  isArray,
  isObject,
  snakeCase,
  transform,
} from 'lodash';

export const toSnakeCase = (obj) => transform(obj, (acc, value, key, target) => {
  const snakeKey = isArray(target) ? key : snakeCase(key);
  acc[snakeKey] = isObject(value) ? toSnakeCase(value) : value;
  return acc;
});

export const toCamelCase = (obj) => transform(obj, (acc, value, key, target) => {
  const camelKey = isArray(target) ? key : camelCase(key);
  acc[camelKey] = isObject(value) ? toCamelCase(value) : value;
  return acc;
});
